import US from 'country-flag-icons/react/3x2/US';
import GB from 'country-flag-icons/react/3x2/GB';
import ZA from 'country-flag-icons/react/3x2/ZA';
import CN from 'country-flag-icons/react/3x2/CN';
import JP from 'country-flag-icons/react/3x2/JP';
import KR from 'country-flag-icons/react/3x2/KR';
import ES from 'country-flag-icons/react/3x2/ES';
import { languages } from '../data';

export const countries = [
  {
    flag: GB,
    code: 'en',
    name: 'English',
  },
  {
    flag: US,
    code: 'us',
    name: 'English (US)',
  },
  {
    flag: ZA,
    code: 'za',
    name: 'English (SA)',
  },
  {
    flag: CN,
    code: 'zh',
    name: '中文 (中国)',
  },
  {
    flag: JP,
    code: 'ja',
    name: '日本語',
  },
  {
    flag: KR,
    code: 'ko',
    name: '한국어',
  },
  {
    flag: ES,
    code: 'es',
    name: 'Español',
  },
];

export const copyright = {
  [languages.en]: 'Copyright 2021 © - All Rights Reserved AU Card LLC.',
  [languages.us]: 'Copyright 2021 © - All Rights Reserved AU Card LLC.',
  [languages.za]: 'Copyright 2021 © - All Rights Reserved AU Card LLC.',
  [languages.zh]: '版权所有 2021 © - 保留所有权利 AU Card LLC。',
  [languages.ja]: 'Copyright 2021 © - All Rights Reserved AU Card LLC.',
  [languages.ko]: 'Copyright 2021 © - 판권 소유 AU 카드 LLC.',
  [languages.es]:
    'Copyright 2021 © - Todos los derechos reservados AU Card LLC.',
};

export const footerMenu = {
  [languages.en]: [
    {
      title: 'Membership Agreements',
      link: '/policies/',
    },
    {
      title: 'Privacy Policy',
      link: '/privacy-policy/',
    },
    {
      title: 'Terms & Conditions',
      link: '/terms-and-conditions/',
    },
    {
      title: 'Terms of Use',
      link: '/terms-of-use/',
    },
    {
      title: 'Consumer Notices',
      link: 'https://coinx.com/consumer-notices/',
    },
  ],
  [languages.us]: [
    {
      title: 'Membership Agreements',
      link: `/${languages.us}/policies/`,
    },
    {
      title: 'Privacy Policy',
      link: `/privacy-policy/`,
    },
    {
      title: 'Terms & Conditions',
      link: `/${languages.us}/coin-x-prepaid-accounts-agreement/`,
    },
    {
      title: 'Terms of Use',
      link: `/${languages.us}/terms-of-use/`,
    },
    {
      title: 'Consumer Notices',
      link: 'https://coinx.com/consumer-notices',
    },
  ],
  [languages.za]: [
    {
      title: 'Membership Agreements',
      link: `/policies/`,
    },
    {
      title: 'Privacy Policy',
      link: `/privacy-policy/`,
    },
    {
      title: 'Terms & Conditions',
      link: `/terms-and-conditions/`,
    },
    {
      title: 'Terms of Use',
      link: `/terms-of-use/`,
    },
    {
      title: 'Consumer Notices',
      link: 'https://coinx.com/consumer-notices/',
    },
  ],
  [languages.zh]: [
    {
      title: '会员协议',
      link: `/policies/`,
    },
    {
      title: '隐私政策',
      link: `/privacy-policy/`,
    },
    {
      title: '条款和条件',
      link: `/terms-and-conditions/`,
    },
    {
      title: '使用条款',
      link: `/terms-of-use/`,
    },
  ],
  [languages.ja]: [
    {
      title: '会員規約',
      link: `/policies/`,
    },
    {
      title: 'プライバシーポリシー',
      link: `/privacy-policy/`,
    },
    {
      title: '利用規約',
      link: `/terms-and-conditions/`,
    },
    {
      title: '利用規約',
      link: `/terms-of-use/`,
    },
  ],
  [languages.ko]: [
    {
      title: '회원 계약',
      link: `/policies/`,
    },
    {
      title: '개인 정보 정책',
      link: `/privacy-policy/`,
    },
    {
      title: '이용약관',
      link: `/terms-and-conditions/`,
    },
    {
      title: '이용약관',
      link: `/terms-of-use/`,
    },
  ],
  [languages.es]: [
    {
      title: 'Acuerdos de membresía',
      link: `/policies/`,
    },
    {
      title: 'Política de privacidad',
      link: `/privacy-policy/`,
    },
    {
      title: 'Términos y condiciones',
      link: `/terms-and-conditions/`,
    },
    {
      title: 'Condiciones de uso',
      link: `/terms-of-use/`,
    },
  ],
};

export const footerText = {
  [languages.en]: `Membership, concierge and lifestyle services offered through AU Card, LLC. \n\nE-money issuance, payments, and card services are solely provided by Nvayo Limited (No. 06035209), authorised by the Financial Conduct Authority under the Electronic Money Regulations 2017 for the issuing of electronic fiat money and payment instruments (Reference number 900005) with registered address: 1 King William Street EC4N 7AF, London, United Kingdom. Your Club Swan Prepaid Card will be issued by Nvayo Limited. Please note the Club Swan card is a regulated electronic money product but it is not covered by the Financial Services Compensation Scheme. We ensure that any funds received by you are held in a segregated account so that in the unlikely event that Nvayo Limited becomes insolvent your funds will be protected against claims made by creditors. \n\nCryptocurrency services are not regulated by the Financial Conduct Authority (FCA). You understand that the price or value of cryptocurrencies can rapidly increase or decrease at any time. The risk of loss in buying, selling or holding cryptocurrencies can be substantial. Cryptocurrencies received by us will not be safeguarded under the UK Electronic Money Regulations 2011 or covered by the Financial Services Compensation Scheme. We do not make any representation regarding the advisability of transacting in cryptocurrencies. We cannot guarantee the timeliness, accurateness, or completeness of any data or information used in connection with you holding any exposure to cryptocurrencies. The information provided on this website is included for reference only and we do not make any representation regarding the accuracy of such data.`,
  [languages.us]: `Membership, concierge and lifestyle services offered through AU Card, LLC. \n\nClub Swan Prepaid Accounts issued to individuals in the United States of America are provided and issued by <a href="https://coinx.com">CoinX Inc</a>., a Money Service Business regulated and registered by FinCEN and by <a href="https://clubswan.com/en-us/policies/states-of-operation/">over 44 states list here</a>. Club Swan Prepaid Account access cards are issued by CoinX. Prepaid Accounts are subject to the terms of the <a href="https://clubswan.com/en-us/policies/coin-x-prepaid-accounts-agreement/">Club Swan Prepaid Account Agreement</a>. \n\nCryptocurrencies may rapidly increase or decrease in value at any time, and may even fall to zero. We are not a broker-dealer and do not provide virtual currencies exchange services, nor do we provide any virtual currency investment products or services. Cryptocurrencies received by Club Swan are not insured by the FDIC, SIPC, or any other Public or Private Insurer. We do not make any representations regarding the advisability of transacting in cryptocurrencies, endorse or rate any virtual currency, nor do we guarantee the accuracy of any information provided regarding cryptocurrencies.\n\nCryptocurrency services are not provided to any resident or consumer in <a href="https://clubswan.com/en-us/policies/states-of-operation/">these states</a>. If you are a resident or consumer located in any of these states, you are not authorized to use the cryptocurrency services.`,
  [languages.za]: `Membership, concierge and lifestyle services offered through AU Card, LLC. \n\nE-money issuance, payments, and card services are solely provided by Nvayo Limited (No. 06035209), authorised by the Financial Conduct Authority under the Electronic Money Regulations 2017 for the issuing of electronic fiat money and payment instruments (Reference number 900005) with registered address: 1 King William Street EC4N 7AF, London, United Kingdom. Your Club Swan Prepaid Card will be issued by Nvayo Limited. Please note the Club Swan card is a regulated electronic money product but it is not covered by the Financial Services Compensation Scheme. We ensure that any funds received by you are held in a segregated account so that in the unlikely event that Nvayo Limited becomes insolvent your funds will be protected against claims made by creditors. \n\nCryptocurrency services are not regulated by the Financial Conduct Authority (FCA). You understand that the price or value of cryptocurrencies can rapidly increase or decrease at any time. The risk of loss in buying, selling or holding cryptocurrencies can be substantial. Cryptocurrencies received by us will not be safeguarded under the UK Electronic Money Regulations 2011 or covered by the Financial Services Compensation Scheme. We do not make any representation regarding the advisability of transacting in cryptocurrencies. We cannot guarantee the timeliness, accurateness, or completeness of any data or information used in connection with you holding any exposure to cryptocurrencies. The information provided on this website is included for reference only and we do not make any representation regarding the accuracy of such data.`,
  [languages.zh]: `通过 AU Card, LLC 提供的会员、礼宾和生活方式服务。 \n\n电子货币发行、支付和卡服务仅由 Nvayo Limited（编号 06035209）提供，由金融行为监管局根据《2017 年电子货币条例》授权发行电子法定货币和支付工具（参考编号 900005）注册地址：1 King William Street EC4N 7AF, London, United Kingdom。您的 Club Swan 预付卡将由 Nvayo Limited 发行。请注意，Club Swan 卡是一种受监管的电子货币产品，但不在金融服务补偿计划的涵盖范围内。我们确保您收到的任何资金都存放在一个隔离账户中，以便万一 Nvayo Limited 资不抵债，您的资金将受到保护，免受债权人提出的索赔。 \n\n加密货币服务不受金融行为监管局 (FCA) 监管。您了解加密货币的价格或价值随时可能快速上涨或下跌。购买、出售或持有加密货币的损失风险可能很大。我们收到的加密货币不受英国 2011 年电子货币条例的保护，也不受金融服务补偿计划的保护。我们不对加密货币交易的可取性做出任何陈述。我们无法保证与您持有任何加密货币敞口有关的任何数据或信息的及时性、准确性或完整性。本网站提供的信息仅供参考，我们不对此类数据的准确性作出任何声明。`,
  [languages.ja]: `AU Card、LLCを通じて提供されるメンバーシップ、コンシェルジュ、ライフスタイルサービス。 \n\n電子マネーの発行、支払い、およびカードサービスは、Nvayo Limited（No。06035209）によってのみ提供され、電子不換紙幣および支払い手段（参照番号900005）の発行について2017年電子マネー規則に基づいて金融行為局によって承認されています。登録住所：1 King William Street EC4N 7AF、ロンドン、イギリス。 ClubSwanプリペイドカードはNvayoLimitedから発行されます。 Club Swanカードは規制された電子マネー製品ですが、金融サービス補償スキームの対象外であることに注意してください。万が一NvayoLimitedが破産した場合に債権者からの請求から資金が保護されるように、お客様が受け取った資金はすべて分離された口座に保管されます。 \n\n暗号通貨サービスは、金融行動監視機構（FCA）によって規制されていません。あなたは、暗号通貨の価格または価値がいつでも急速に増減する可能性があることを理解しています。暗号通貨の購入、販売、または保有における損失のリスクはかなりのものになる可能性があります。私たちが受け取った暗号通貨は、2011年の英国電子マネー規制の下で保護されたり、金融サービス補償スキームの対象になったりすることはありません。私たちは、暗号通貨での取引の妥当性に関していかなる表明もしません。私たちは、暗号通貨への露出を保持しているあなたに関連して使用されるデータまたは情報の適時性、正確性、または完全性を保証することはできません。このウェブサイトで提供される情報は参照のみを目的として含まれており、そのようなデータの正確性に関していかなる表明も行いません。`,
  [languages.ko]: `AU Card, LLC를 통해 제공되는 멤버십, 컨시어지 및 라이프스타일 서비스. \n\n전자 화폐 발행, 지불 및 카드 서비스는 전자 화폐 및 지불 수단(참조 번호 900005)의 발행을 위해 전자 화폐 규정 2017에 따라 금융 행위 당국의 승인을 받은 Nvayo Limited(No. 06035209)에서 단독으로 제공합니다. 등록 주소: 1 King William Street EC4N 7AF, London, United Kingdom. Club Swan 선불 카드는 Nvayo Limited에서 발급합니다. Club Swan 카드는 규제 대상인 전자 화폐 상품이지만 금융 서비스 보상 제도가 적용되지 않습니다. Nvayo Limited가 지급 불능 상태가 되는 경우에 귀하의 자금이 채권자의 청구로부터 보호될 수 있도록 귀하가 수령한 모든 자금은 분리된 계정에 보관됩니다. \n\n암호화폐 서비스는 FCA(Financial Conduct Authority)의 규제를 받지 않습니다. 암호화폐의 가격이나 가치는 언제든지 빠르게 오르거나 내릴 수 있음을 이해합니다. 암호화폐 구매, 판매 또는 보유에 따른 손실 위험은 상당할 수 있습니다. 당사가 수령한 암호화폐는 영국 전자 화폐 규정 2011 또는 금융 서비스 보상 제도에 의해 보호되지 않습니다. 우리는 암호화폐 거래의 타당성과 관련하여 어떠한 진술도 하지 않습니다. 당사는 암호화폐에 노출된 귀하와 관련하여 사용된 데이터 또는 정보의 적시성, 정확성 또는 완전성을 보장할 수 없습니다. 이 웹사이트에 제공된 정보는 참조용으로만 포함되며 당사는 그러한 데이터의 정확성에 대해 어떠한 진술도 하지 않습니다.`,
  [languages.es]: `Servicios de membresía, conserjería y estilo de vida ofrecidos a través de AU Card, LLC. \n \nLa emisión de dinero electrónico, los pagos y los servicios de tarjeta son proporcionados únicamente por Nvayo Limited (No. 06035209), autorizado por la Autoridad de Conducta Financiera según las Regulaciones de Dinero Electrónico de 2017 para la emisión de dinero fiduciario electrónico e instrumentos de pago (Número de referencia 900005) con domicilio social: 1 King William Street EC4N 7AF, Londres, Reino Unido. Su tarjeta prepaga Club Swan será emitida por Nvayo Limited. Tenga en cuenta que la tarjeta Club Swan es un producto de dinero electrónico regulado, pero no está cubierto por el Plan de compensación de servicios financieros. Nos aseguramos de que los fondos que reciba se mantengan en una cuenta separada para que, en el caso poco probable de que Nvayo Limited se declare insolvente, sus fondos estarán protegidos contra las reclamaciones de los acreedores. \n \nLos servicios de criptomonedas no están regulados por la Autoridad de Conducta Financiera (FCA). Entiende que el precio o el valor de las criptomonedas puede aumentar o disminuir rápidamente en cualquier momento. El riesgo de pérdida al comprar, vender o mantener criptomonedas puede ser sustancial. Las criptomonedas que recibamos no estarán protegidas por las Regulaciones de Dinero Electrónico del Reino Unido de 2011 ni cubiertas por el Plan de Compensación de Servicios Financieros. No hacemos ninguna representación con respecto a la conveniencia de realizar transacciones en criptomonedas. No podemos garantizar la puntualidad, exactitud o integridad de cualquier dato o información utilizada en relación con su exposición a las criptomonedas. La información proporcionada en este sitio web se incluye solo como referencia y no hacemos ninguna representación con respecto a la exactitud de dichos datos.`,
};
